/**
 * Represents a microphone error.
 *
 * Ref:
 * https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/getUserMedia#exceptions
 */
export type MicrophoneError =
  | 'PermissionDeniedError'
  | 'NotFoundError'
  | 'AbortError'
  | 'NotAllowedError'
  | 'NotReadableError'
  | 'OverConstrainedError'
  | 'SecurityError';

/** Represents error for when the browser audio throws an error. */
export type RequestMicrophoneAccessError = {
  /** The error. */
  readonly name: MicrophoneError;
};

/** Requests audio access from the browser. */
export async function requestMicrophoneAccess(): Promise<void> {
  const mediaStream = await window.navigator.mediaDevices.getUserMedia({
    audio: true,
  });

  const [track] = mediaStream.getTracks();
  track.stop();
}
